// 解释科研项目各种参数类型
import services from "../../services";
/**
 * 项目/统计归属
 * @param {*} id SUBJECT_CLASS_ID
 * @returns 
 */
const getSubjectClassName = (id) => {
	if (id === null || id === undefined) {
		return id;
	} else if (id == 1) {
		return '社科类'
	} else if (id == 2) {
		return '科技类'
	} else if (id == 3) {
		return '资助类'
	}
}


/**
 * 项目状态
 * @param {*} id SUBJECT_CLASS_ID
 * @returns 
 */
const getProjectStatus = (id) => {
	if (id === null || id === undefined) {
		return id;
	} else if (id == '2001') {
		return '进行'
	} else if (id == '2002') {
		return '暂存'
	} else if (id == '2003') {
		return '撤销'
	} else if (id == '2004') {
		return '结项'
	} else if (id == '2005') {
		return '完成'
	} else if (id == '2006') {
		return '作废'
	} else if (id == '2007') {
		return '变更'
	}

}

/**
 * 申报状态
 * @param {*} id APPLY_STATE
 * @returns 
 */
 const getApplyState = (id) => {
	if (id === null || id === undefined) {
		return id;
	} else if (id == '2010') {
		return '未启动'
	} else if (id == '2011') {
		return '进行'
	} else if (id == '2012') {
		return '已停止'
	}

}

/**
 * 审核状态
 * @param {*} id CHECK_STATUS
 * @returns 
 */
const getCheckStatus = (id) => {
	if (id === null || id === undefined) {
		return id;
	} else if (id == '1601') {
		return '已提交'
	} else if (id == '1602') {
		return '学院通过'
	} else if (id == '1603') {
		return '学校通过'
	} else if (id == '1604') {
		return '学院退回'
	} else if (id == '1605') {
		return '学校退回'
	} else if (id == '1606') {
		return '暂存'
	} else if (id == '1607') {
		return '待完善'
	} else if (id == '1608') {
		return '待确认'
	} else if (id == '1609') {
		return '作废'
	}

}


/**
 * 项目成员类型
 * @param {*} id 
 * @returns 
 */
const getMemberType = (id) => {
	let value = "";
	if (id === null || id === undefined) {
		return value;
	} else if (employeeTypeMap === undefined || employeeTypeMap.length === 0) {
		return value;
	} else {
		employeeTypeMap.forEach(e => {
			if (e.value == id) value = e.label;
		})
	}
	return value;
}

/**
 * 承担类型
 * @param {*} id CHECK_STATUS
 * @returns 
 */
const getBearTypeId = (id) => {
	if (id === null || id === undefined) {
		return id;
	} else if (id == '1') {
		return '负责人'
	} else if (id == '2') {
		return '参与人员'
	} else {
		return undefined;
	}

}




/**
 * 参与状态
 * @param {*} id JOIN_STATE
 * @returns 
 */
const getJoinState = (id) => {
	if (id === null || id === undefined || id === "exist") {
		return '参与';
	} else if (id === 'exit') {
		return '申请退出'
	} else if (id == 'join') {
		return '申请加入'
	} else {
		return undefined;
	}

}

// 职工类型列表，由字典表获取
let employeeTypeMap = [];
const setEmployeeTypeMap = () => {
	services.employee.queryPropertiesList().then(res => {
		employeeTypeMap = res;
	})

}


/**
 * 负责人类型
 * @param {*} id CHECK_STATUS
 * @returns 
 */

const getChargerType = (id) => {
	let value = "";
	if (id === null || id === undefined) {
		return value;
	} else if (employeeTypeMap === undefined || employeeTypeMap.length === 0) {
		return value;
	} else {
		employeeTypeMap.forEach(e => {
			if (e.value == id) value = e.label;
		})
	}
	return value;
}



/**
 * 学位
 * @deprecated
 * @param {*} id CHECK_STATUS
 * @returns 
 */
const getEduDegreeId = (id) => {
	if (id === null || id === undefined || id === '') {
		return undefined;
	} else if (id == '1') {
		return '博士'
	} else if (id == '2') {
		return '硕士'
	} else if (id == '3') {
		return '学士'
	} else {
		return '无'
	}

}


/**
 * 负责人类型
 * @param {*} id alterType
 * @returns 
 */
const getAlterType = (value) => {
	if (value === null || value === undefined) {
		return value;
	} else if (value == 'budgetChange') {
		return '预算变更'
	} else if (value == 'memberChange') {
		return '成员变更'
	} else if (value == 'chargerChange') {
		return '负责人变更'
	} else if (value == 'timeChange') {
		return '延期变更'
	} else if (value == 'stopChange') {
		return '终止变更'
	}

}

/**
 * 签订状态
 * @param {*} id CHECK_STATUS
 * @returns 
 */
const getSignedStatus = (id) => {
	if (id === null || id === undefined || id === '') {
		return undefined;
	} else if (id == '0') {
		return '未签订'
	} else if (id == '1') {
		return '已签订'
	}

}


/**
 * 通用级别
 * @param {*} id DEFAULT_LEVEL
 * @returns 
 */
 const getDefaultLevel = (id) => {
	if (id === null || id === undefined || id === '') {
		return undefined;
	} else if (id == '1') {
		return '国家级'
	} else if (id == '2') {
		return '部级'
	} else if (id == '3') {
		return '省级'
	} else if (id == '4') {
		return '地市级'
	} else if (id == '5') {
		return '校级'
	} else if (id == '6') {
		return '其他'
	}

}

/**
 * 项目级别
 * @param {*} id PROJECT_LEVEL_ID
 * @returns 
 */
const getProjectLevelId = (id) => {
	
	id = Number(id)
	let value = "";
	if (id === null || id === undefined) {
		return value;
	} else if (projectLevelMap === undefined || projectLevelMap.length === 0) {
		return value;
	} else {
		projectLevelMap.forEach(e => {
			if (e.value == id) value = e.label;
		})
	}
	return value;
}

let projectLevelMap = [];

const loadProjectLevel = () => {
	services.scientificResearch.base.baseResource.queryProjectLevelList().then(res => {
		projectLevelMap = res;
	})
}

/**
 * 项目等级
 * @param {*} id PROJECT_GRADE_ID
 * @returns 
 */
const getProjectGrade = (id) => {
	if (id === null || id === undefined || id === '') {
		return "";
	} else if (id == '1') {
		return '重大'
	} else if (id == '2') {
		return '重点'
	} else if (id == '3') {
		return '一般'
	} else if (id == '4') {
		return '青年'
	} else if (id == '5') {
		return '其他'
	}

}

/**
 * 验收类别
 * @param {*} type ACCEPTANCE_TYPE
 * @returns 
 */
const getAcceptanceType = (type) => {
	if (type === null || type === undefined || type === '') {
		return "";
	} else if (type == '1') {
		return '技术验收'
	} else if (type == '2') {
		return '财务验收'
	} else if (type == '3') {
		return '混合验收'
	}


}

/**
 * 合同类别
 * @param {*} type ACCEPTANCE_TYPE
 * @returns 
 */
const getContractType = (type) => {
	if (type === null || type === undefined || type === '') {
		return "";
	} else if (type == '1') {
		return '技术开发'
	} else if (type == '2') {
		return '技术转让'
	} else if (type == '3') {
		return '技术咨询'
	} else if (type == '4') {
		return '技术服务'
	} else if (type == '5') {
		return '采购'
	} else if (type == '6') {
		return '其他'
	}


}

/**
 * 免税状态
 * @param {*} type EXEMPTION_STATE
 * @returns 
 */
const getExemptionState = (type) => {
	if (type === null || type === undefined || type === '') {
		return "";
	} else if (type == '1') {
		return '未免税'
	} else if (type == '2') {
		return '已免税'
	}
}

/**
 * 承担角色类型
 * @param {*} id CHECK_STATUS
 * @returns 
 */
const getBearRoleTypeId = (id) => {
	if (id === null || id === undefined) {
		return id;
	} else if (id == '1') {
		return '第一作者'
	} else if (id == '2') {
		return '参与作者'
	} else {
		return undefined;
	}

}

/**
 * 专利权状态
 * @param {*} id 
 * @returns 
 */
const getPatentRightState = (id) => {
	if (id === null || id === undefined) {
		return id;
	} else if (id == '1') {
		return '未生效'
	} else if (id == '2') {
		return '有效'
	} else if (id == '3') {
		return '已转出'
	} else if (id == '4') {
		return '无效'
	} else {
		return undefined;
	}

}


// 由字典表获取数据类型
let paperTypeMap = [];
let employTypeMap = [];
let publicRangeMap = [];
let paperLevelMap = [];
let pageSpaceMap = [];
let bookTypeMap = [];

const loadBaseData = () => {
	services.scientificResearch.base.baseResource.queryPaperTypeList().then(res => {
		employTypeMap = res;
	})
	services.scientificResearch.base.baseResource.queryEmployTypeList().then(res => {
		employeeTypeMap = res;
	})
	services.scientificResearch.base.baseResource.queryPaperLevelList().then(res => {
		paperLevelMap = res;
	})
	services.scientificResearch.base.baseResource.queryPublishRangeList().then(res => {
		publicRangeMap = res;
	})
	services.scientificResearch.base.baseResource.queryPageSpaceList().then(res => {
		pageSpaceMap = res;
	})
	services.scientificResearch.base.baseResource.queryBookTypeList().then(res => {
		bookTypeMap = res;
	})
}

/**
 * 收录类别
 * @param {*} id 
 * @returns 
 */

const getEmployType = (id) => {
	let value = "";
	if (id === null || id === undefined) {
		return value;
	} else if (employTypeMap === undefined || employTypeMap.length === 0) {
		return value;
	} else {
		employTypeMap.forEach(e => {
			if (e.value == id) value = e.label;
		})
	}
	return value;
}

/**
 * 著作类别
 * @param {*} id 
 * @returns 
 */

const getBookType = (id) => {
	let value = "";
	if (id === null || id === undefined) {
		return value;
	} else if (bookTypeMap === undefined || bookTypeMap.length === 0) {
		return value;
	} else {
		bookTypeMap.forEach(e => {
			if (e.value == id) value = e.label;
		})
	}
	return value;
}



/**
 * 版面 
 * @param {*} id 
 * @returns 
 */

const getPageSpace = (id) => {
	let value = "";
	if (id === null || id === undefined) {
		return value;
	} else if (pageSpaceMap === undefined || pageSpaceMap.length === 0) {
		return value;
	} else {
		pageSpaceMap.forEach(e => {
			if (e.value == id) value = e.label;
		})
	}
	return value;
}

/**
 * 论文级别 
 * @param {*} id 
 * @returns 
 */

const getPaperLevel = (id) => {
	let value = "";
	if (id === null || id === undefined) {
		return value;
	} else if (paperLevelMap === undefined || paperLevelMap.length === 0) {
		return value;
	} else {
		paperLevelMap.forEach(e => {
			if (e.value == id) value = e.label;
		})
	}
	return value;
}


/**
 * 发表范围 
 * @param {*} id 
 * @returns 
 */

const getPublicRange = (id) => {
	let value = "";
	if (id === null || id === undefined) {
		return value;
	} else if (publicRangeMap === undefined || publicRangeMap.length === 0) {
		return value;
	} else {
		publicRangeMap.forEach(e => {
			if (e.value == id) value = e.label;
		})
	}
	return value;
}

/**
 * 论文类型
 * @param {*} id 
 * @returns 
 */

const getPaperType = (id) => {
	let value = "";
	if (id === null || id === undefined) {
		return value;
	} else if (paperTypeMap === undefined || paperTypeMap.length === 0) {
		return value;
	} else {
		paperTypeMap.forEach(e => {
			if (e.value == id) value = e.label;
		})
	}
	return value;
}




/**
 * 学校署名
 * @param {*} id 
 * @returns 
 */
const getSchoolSign = (id) => {
	if (id === null || id === undefined) {
		return id;
	} else if (id == '1') {
		return '第一单位'
	} else if (id == '0') {
		return '非第一单位'
	} else {
		return undefined;
	}
}

/**
 * 专利状态
 * @param {*} id 
 * @returns 
 */
const getPatentState = (id) => {
	if (id === null || id === undefined) {
		return id;
	} else if (id == '1') {
		return '专利申请'
	} else if (id == '2') {
		return '专利公开'
	} else if (id == '3') {
		return '专利授权'
	} else if (id == '4') {
		return '专利撤回'
	} else if (id == '5') {
		return '专利驳回'
	} else if (id == '6') {
		return '专利终止'
	} else if (id == '7') {
		return '专利转移'
	} else {
		return undefined;
	}
}

/**
 * 合作类型
 * @param {*} id 
 * @returns 
 */
const getCooperateType = (id) => {
	if (id === null || id === undefined || id === '') {
		return "";
	} else if (id == '1') {
		return '独立申请'
	} else if (id == '2') {
		return '联合申请'
	}

}

let reportTypeMap = [];
let productTypeMap = [];
let artFormMap = [];
let copyrightMap = [];
let patentTypeMap = [];

const loadBaseData2 = () => {
	services.scientificResearch.base.baseResource.queryReportTypeList().then(res => {
		reportTypeMap = res;
	})
	services.scientificResearch.base.baseResource.queryProductTypeList().then(res => {
		productTypeMap = res;
	})
	services.scientificResearch.base.baseResource.queryArtFormList().then(res => {
		artFormMap = res;
	})
	services.scientificResearch.base.baseResource.queryCopyrightTypeList().then(res => {
		copyrightMap = res;
	})
	services.scientificResearch.base.baseResource.queryPatentTypeList().then(res => {
		patentTypeMap = res;
	})
}

/**
 * 专利类型
 * @param {*} id 
 * @returns 
 */

const getPatentType = (id) => {
	let value = "";
	if (id === null || id === undefined) {
		return value;
	} else if (patentTypeMap === undefined || patentTypeMap.length === 0) {
		return value;
	} else {
		patentTypeMap.forEach(e => {
			if (e.value == id) value = e.label;
		})
	}
	return value;
}


/**
 * 展播形式类型
 * @param {*} id 
 * @returns 
 */

const getArtForm = (id) => {
	let value = "";
	if (id === null || id === undefined) {
		return value;
	} else if (artFormMap === undefined || artFormMap.length === 0) {
		return value;
	} else {
		artFormMap.forEach(e => {
			if (e.value == id) value = e.label;
		})
	}
	return value;
}


/**
 * 著作权类型
 * @param {*} id 
 * @returns 
 */

const getCopyrightType = (id) => {
	let value = "";
	if (id === null || id === undefined) {
		return value;
	} else if (copyrightMap === undefined || copyrightMap.length === 0) {
		return value;
	} else {
		copyrightMap.forEach(e => {
			if (e.value == id) value = e.label;
		})
	}
	return value;
}

/**
 * 艺术作品类型
 * @param {*} id 
 * @returns 
 */

const getProductType = (id) => {
	let value = "";
	if (id === null || id === undefined) {
		return value;
	} else if (productTypeMap === undefined || productTypeMap.length === 0) {
		return value;
	} else {
		productTypeMap.forEach(e => {
			if (e.value == id) value = e.label;
		})
	}
	return value;
}


/**
 * 报告类型
 * @param {*} id 
 * @returns 
 */
const getReportType = (id) => {
	let value = "";
	if (id === null || id === undefined) {
		return value;
	} else if (reportTypeMap === undefined || reportTypeMap.length === 0) {
		return value;
	} else {
		reportTypeMap.forEach(e => {
			if (e.value == id) value = e.label;
		})
	}
	return value;
}

let honorTypeMap = [];
let honorLevelMap = [];
let honorGradeMap = [];
let honorClassMap = [];

const loadBaseDataForHonor = () => {
	services.scientificResearch.base.baseResource.queryHonorClassList().then(res => {
		honorClassMap = res;
	})
	services.scientificResearch.base.baseResource.queryHonorGradeList().then(res => {
		honorGradeMap = res;
	})
	services.scientificResearch.base.baseResource.queryHonorLevelList().then(res => {
		honorLevelMap = res;
	})
	services.scientificResearch.base.baseResource.queryHonorTypeList().then(res => {
		honorTypeMap = res;
	})
}


/**
 * 获奖类型
 * @param {*} id Class
 * @returns 
 */
const getHonorClass = (id) => {
	let value = "";
	if (id === null || id === undefined) {
		return value;
	} else if (honorClassMap === undefined || honorClassMap.length === 0) {
		return value;
	} else {
		honorClassMap.forEach(e => {
			if (e.value == id) value = e.label;
		})
	}
	return value;
}

/**
 * 获奖等级
 * @param {*} id 
 * @returns 
 */
const getHonorGrade = (id) => {
	let value = "";
	if (id === null || id === undefined) {
		return value;
	} else if (honorGradeMap === undefined || honorGradeMap.length === 0) {
		return value;
	} else {
		honorGradeMap.forEach(e => {
			if (e.value == id) value = e.label;
		})
	}
	return value;
}

/**
 * 获奖级别
 * @param {*} id 
 * @returns 
 */
const getHonorLevel = (id) => {
	let value = "";
	if (id === null || id === undefined) {
		return value;
	} else if (honorLevelMap === undefined || honorLevelMap.length === 0) {
		return value;
	} else {
		honorLevelMap.forEach(e => {
			if (e.value == id) value = e.label;
		})
	}
	return value;
}

/**
 * 获奖类型
 * @param {*} id 
 * @returns 
 */
const getHonorType = (id) => {
	let value = "";
	if (id === null || id === undefined) {
		return value;
	} else if (honorTypeMap === undefined || honorTypeMap.length === 0) {
		return value;
	} else {
		honorTypeMap.forEach(e => {
			if (e.value == id) value = e.label;
		})
	}
	return value;
}


export default {
	getSubjectClassName,
	getProjectStatus,
	getCheckStatus,
	getChargerType,
	getBearTypeId,
	getMemberType,
	getEduDegreeId,
	getAlterType,
	getSignedStatus,
	getProjectLevelId,
	getProjectGrade,
	setEmployeeTypeMap,
	getJoinState,
	getAcceptanceType,
	getContractType,
	getExemptionState,
	getBearRoleTypeId,
	getPaperType,
	loadBaseData,
	getPublicRange,
	getPaperLevel,
	getPageSpace,
	getEmployType,
	getSchoolSign,
	getBookType,
	getReportType,
	loadBaseData2,
	getArtForm,
	getProductType,
	getCopyrightType,
	getPatentType,
	getPatentState,
	getCooperateType,
	getPatentRightState,
	loadBaseDataForHonor,
	getHonorClass,
	getHonorLevel,
	getHonorGrade,
	getHonorType,
	loadProjectLevel,
	getDefaultLevel,
	getApplyState
}